import { Alert } from 'react-bootstrap';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import dayjs from 'dayjs';
import { FormBlock } from '../../common/Forms';
import { useSelector } from 'react-redux';

export function RequestData(props) {
    const { request, executing, errors, updateData, clearErrors, readOnly } = props;
    const [editDataField, setEditDataField] = useState(null);
    const { nomination } = request;

    useEffect(() => {
        clearErrors();
    }, [editDataField, clearErrors]);

    useEffect(() => {
        return () => clearErrors();
    }, [clearErrors]);

    useEffect(() => {
        if (!executing && !errors) setEditDataField(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [executing]);

    const handleEditClick = useCallback(
        (e, field) => {
            if (executing) return;
            setEditDataField(field.id);
        },
        [executing]
    );
    const handleCancelClick = useCallback(() => {
        if (executing) return;
        setEditDataField(null);
    }, [executing]);
    const handleSubmit = useCallback(
        (e, field, value) => {
            if (executing) return;
            let val = value;
            if (field.inputType === 'date') {
                const date = dayjs(value);
                val = date.isValid() ? date.format('DD.MM.YYYY') : null;
            }
            updateData({ requestId: +request.id, fieldId: +field.id, value: val });
        },
        [executing, request, updateData]
    );

    const user = useSelector((state) => state.auth.user);
    const extDataReadOnly = useMemo(() => {
        return (
            !user || // не авторизован (почему-то)
            !request || // нет такой заявки
            user.id !== request.author.id || // не автор заявки (просто участник)
            // прошло больше 8 дней от завершения сбора материалов
            (!request.forceEditable && dayjs().isAfter(dayjs(nomination.changeStopDate).add(8, 'day'))) ||
            // прием заявок не открыт (если вдруг пришлось сдвинуть, но заявки уже созданы)
            dayjs().isBefore(dayjs(nomination.regOpenDate))
        );
    }, [user, request, nomination]);

    return (
        <>
            <FormBlock
                title="Данные"
                fields={nomination.dataFields}
                fieldsData={request.fields}
                executing={executing}
                errors={errors}
                clearErrors={clearErrors}
                readOnly={readOnly}
                editDataField={editDataField}
                onEdit={handleEditClick}
                onCancel={handleCancelClick}
                onSubmit={handleSubmit}
                request={request}
            />
            <FormBlock
                title="Дополнительные данные"
                fields={nomination.extDataFields}
                fieldsData={request.extData}
                executing={executing}
                errors={errors}
                clearErrors={clearErrors}
                readOnly={extDataReadOnly}
                editDataField={editDataField}
                onEdit={handleEditClick}
                onCancel={handleCancelClick}
                onSubmit={handleSubmit}
                id="extData"
                request={request}
            >
                <Alert variant={'warning'}>
                    Данный блок содержит дополнительную информацию, которая не влияет на отбор, но необходима для
                    организации выступлений непосредственно на фестивале. Поля данного блока обязательны к заполнению,
                    если ваша заявка прошла отбор. Вы можете заполнить эти поля сразу, либо в течение 3х дней с момента
                    получения заявкой статуса "Одобрена". По истечению этого срока доступ к редактированию данных полей
                    будет закрыт.
                </Alert>
            </FormBlock>
        </>
    );
}
